import { swSettings } from "app/common/services/swSettings";
import { ProjectsDunningsBanner } from "app/components/Dunnings/ProjectsDunningsBanner/ProjectsDunningsBanner";
import { useDunnings } from "app/components/hooks/useDunnings";
import { Alerts } from "app/pages/activation/components/HomeWithData/Alerts/Alerts";
import { SetupModal } from "app/pages/activation/components/SetupModal/SetupModal";
import { useHomeContext } from "app/pages/activation/context/Home/HomeContext";
import { useToggle } from "app/pages/activation/hooks/useToggle";

import { Header } from "./Header/Header";
import { Insights } from "./Insights/Insights";
import { Projects } from "./Projects/Projects";
import { RecentActivity } from "./RecentActivity/RecentActivity";
import { SearchBar } from "./SearchBar/SearchBar";
import { ShareData } from "./ShareData/ShareData";
import * as SC from "./styles";

export const HomeWithData = () => {
    const { existingNames, totalNumber, isActivationLoading } = useHomeContext();
    const [isSetupOpen, onOpenSetup, onCloseSetup] = useToggle();
    const isAlertsAvailable = !!swSettings.components.Alerts?.isAllowed;
    const isInsightsAvailable = !!swSettings.components.ActivationInsights?.isAllowed;
    const { isInRetryProcess } = useDunnings();

    return (
        <>
            <SetupModal
                isOpen={isSetupOpen}
                onClose={onCloseSetup}
                existingNames={existingNames}
                resetStateOnClose
            />

            <SC.Container>
                <SC.ContentContainer>
                    <Header />

                    <SearchBar />

                    {!isActivationLoading ? <RecentActivity /> : null}

                    {isInRetryProcess ? <ProjectsDunningsBanner /> : null}

                    <SC.DataContainer>
                        <Projects onClickCreateProject={onOpenSetup} />

                        <ShareData onCreateProject={onOpenSetup} />

                        {isInsightsAvailable ? <Insights /> : null}

                        {isAlertsAvailable ? <Alerts onClickCreateProject={onOpenSetup} /> : null}
                    </SC.DataContainer>
                </SC.ContentContainer>
            </SC.Container>
        </>
    );
};
